import { StringValues } from '../interfaces/undetermined';

// Constante que guarda el nombre de los atributos que recibe el API de reportes, segun nombre en los formularios
export const REPORTS: StringValues = {
  description: "description",
  agreementStatus: "state",
  agreement: "agreement",
  manager: "encargado",
  operation: "ope",
  month2: "month2",
  entities: "ent",
  enDate: "date",
  month: "month",
  year2: "year2",
  entity: "ent",
  year: "year",
  type: "type",
  name: "name",
  file: "file",
};
